import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './component/home/Home';
import './assets/css/font_awesome.css'
import '../src/assets/css/comman.css'
import About from './component/about/About';
import Contact from './component/contact/Contact';
import Header from './component/include/Header';
import Footer from './component/include/Footer';
import WhatWeDoPage from './component/whatwedo/WhatWeDoPage';
import ScrollToTop from './component/ScrollToTop';


function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/whatwedo" element={<WhatWeDoPage />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
    <Footer />
  </Router>
  );
}

export default App;
